"use client";

import { Button } from "@shared/ui/button";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <div className="flex min-h-[640px] w-full flex-col items-center justify-center gap-4">
      <div className="mx-auto flex min-h-[240px] min-w-[320px] flex-col items-center justify-center gap-4 rounded-xl bg-gray-900 p-8 shadow-sm">
        <h1 className="text-xl">Oops! Something went wrong</h1>
        <p>We're having trouble processing your request. Please refresh or try again later.</p>
        <Button onClick={() => reset()}>Try again</Button>

        {process.env.NODE_ENV === "development" && (
          <div className="mt-4">
            <p>Error Details for development:</p>
            <pre>{error.message}</pre>
          </div>
        )}
      </div>
    </div>
  );
}
